import { CSSProperties } from 'react';

import {
  amber,
  blue,
  blueOpacities,
  catastrophic,
  critical,
  green,
  grey,
  high,
  lightBlue,
  lightGreen,
  low,
  medium,
  orange,
  pink,
  red,
  teal,
  total,
  yellow,
} from '../colors';
import { cyan } from '../colors/cyan';
import { deepPurple } from '../colors/deepPurple';
import { lime } from '../colors/lime';
import { purple } from '../colors/purple';
import { SecurityApplicationsThemeOptions } from '../types';

export const lightPaletteThemeOptions: SecurityApplicationsThemeOptions = {
  palette: {
    mode: 'light',

    primary: {
      dark: blue[700],
      main: blue[500],
      light: blue[300],
    },

    divider: grey[100],

    severity: {
      total,
      catastrophic,
      critical,
      high,
      medium,
      low,
    },

    shades: blueOpacities,

    amber,
    blue,
    green,
    lightBlue,
    lightGreen,
    lime,
    cyan,
    orange,
    pink,
    purple,
    deepPurple,
    red,
    teal,
    yellow,
  },
};

export type colorPalette = {
  main?: CSSProperties['color'];
  active?: CSSProperties['color'];
  primary?: CSSProperties['color'];
  A800?: CSSProperties['color'];
  A700?: CSSProperties['color'];
  800?: CSSProperties['color'];
  700?: CSSProperties['color'];
  600?: CSSProperties['color'];
  500?: CSSProperties['color'];
  300?: CSSProperties['color'];
  200?: CSSProperties['color'];
  100?: CSSProperties['color'];
  50?: CSSProperties['color'];
};
